export default "__VITE_ASSET__5cL2fFKE__"